import { Injectable } from '@angular/core';

@Injectable()
export class ActorHueService {

  private readonly _hues = [
    0,
    180,
    90,
    270,
    45,
    225,
    135,
    315,
    22,
    202,
    68,
    248,
    112,
    292,
    157,
    337
  ]

  private readonly _actorHues: { [actorId: string]: { insertedAt: number, hueIdx: number } } = {}

  constructor() {

  }

  getHue(actorId: string) {


    if (this._actorHues[actorId]) {
      const hueIdx = this._actorHues[actorId].hueIdx;
      return this._hues[hueIdx % this._hues.length];
    }

    const lastInserted = Object.values(this._actorHues).reduce((max, current) => {

      if (!max || current.hueIdx > max.hueIdx) {
        return current;
      }

      return max;
    },
      undefined
    )

    const hueIdx = lastInserted ? lastInserted.hueIdx + 1 : 0;
    this._setHue({ hueIdx, actorId })

    return this._hues[hueIdx % this._hues.length];
  }

  private _setHue(params: { hueIdx: number, actorId: string }) {
    const { actorId, hueIdx } = params;

    this._actorHues[actorId] = { hueIdx, insertedAt: new Date().getTime() };

  }


  removeActorHue(actorId: string) {
    delete this._actorHues[actorId]
  }
}
